import React, { useState } from 'react';
import './AboutCompanyStyles/AboutCompany.scss';
import ettikImage from '../../assets/images/about_Ettikgroup.png';
import ParagraphAnimation from '../../components/TextAnimation/ParagraphAnimation';

const AboutCompany = () => {
  const [showAll, setShowAll] = useState(false);

  const paragraphs = [
    "Ettik Group is a globally active technology and engineering partner, supporting companies with smart, scalable solutions in IT, software development, industrial engineering, and international talent placement.",
    "We are close to our clients when it matters most – especially when it comes to implementing complex projects. With delivery centers in India and Vietnam and a presence in Europe, we combine global reach with local execution.",
    "Founded in 2019, Ettiksoft quickly developed into a trusted supplier for leading Tier-1 companies in the automotive sector. This early success laid the foundation for rapid growth and the establishment of additional companies in new domains. Today, these entities form a strong group of specialized engineering companies operating under the Ettik brand.",
    "Our business is built on strong values: commitment to quality, continuous progress, employee empowerment, and long-term client relationships. Whether it’s embedded systems, cloud platforms, custom machinery, or recruiting top talent – Ettik Group delivers reliable results across borders and industries."
  ];

  const visibleParagraphs = showAll ? paragraphs : paragraphs.slice(0, 2);

  return (
    <div className="about-section-wrapper py-5">
      <div className="fullscreen light-section pt-5">
        <div className="row">
          {/* Left Content */}
          <div className="col-lg-6 d-flex text-left justify-content-space-between">
            <div className='row'>
              <p className="section-title"><ParagraphAnimation>about Ettik Group</ParagraphAnimation></p>
              <div className="flex-grow-1 d-flex flex-column justify-content-end">
                <div className='about-text'>
                  {visibleParagraphs.map((text, index) => (
                    <p key={index}>{text}</p>
                  ))}

                  {/* Toggle Button */}
                  <button className="view-toggle-btn" onClick={() => setShowAll(!showAll)}>
                    {showAll ? "View Less" : "View More"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="col-lg-6 mt-4 mt-lg-0">
            <img src={ettikImage} alt="Ettik Group Building" className="img-fluid about-img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutCompany;
